<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box text-center">
          <!-- /.box-header -->
          <div class="del-block m-t-5" v-if="up">
            <div class="btn btn-danger" data-toggle="modal" data-target="#delModal">
              <i class="fa fa-trash"></i>
            </div>
          </div>
          <div class="box-body form" style="display: flex; flex-direction: column; align-items: center;">
            <br/>
            <div>
              <div>
              <!-- 品牌 -->
                <div class="input-group" style="max-width: 400px" v-if="brandBrief.length > 1 && !up">
                  <span class="input-group-addon" style="width: 120px; text-align: left;">
                    <span class="text-red">＊ </span>品牌
                  </span>
                  <!-- <select class="form-control h-38" v-model="brandSelect">
                    <option v-for="brand in brandBrief" :value="brand.value">
                      {{brand.label}}
                    </option>
                  </select> -->
                  <multiselect
                      v-model="brandSelect"
                      :options="brandBrief"
                      :searchable="true"
                      :allow-empty="false"
                      :close-on-select="true"
                      placeholder="==品牌=="
                      :show-labels="false"
                      :multiple="false"
                      label="label"
                      track-by="value"
                      style="width: 280px"
                  >
                  </multiselect>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group" style="max-width: 400px">
                  <span class="input-group-addon" style="width: 120px; text-align: left;">
                    設定名稱
                  </span>
                  <input class="form-control" style="width: 280px" placeholder="備註用，不會顯示在菜單" type="text" v-model="name" maxlength="32">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group" style="max-width: 400px">
                  <span class="input-group-addon" style="width: 120px; text-align: left;">
                    設定描述
                  </span>
                  <input class="form-control" style="width: 280px" placeholder="備註用，不會顯示在菜單" type="text" v-model="description" maxlength="32">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group cr-schedule cr-ad" style="max-width: calc(30vw - 190px)">
                <span class="input-group-addon" style="text-align: left;">
                  <span class="text-red">＊ </span>開始時間
                </span>
                <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
                  <!--<input class="form-control w-200" placeholder="" type="text" v-model="menuTime.start">-->
                </div>
                <br />
              </div>
              <div>
                <div class="input-group cr-schedule cr-ad" style="max-width: calc(30vw - 190px)">
                <span class="input-group-addon" style="text-align: left;">
                  <span class="text-red">＊ </span>結束時間
                </span>
                <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
                  <!--<input class="form-control w-200" placeholder="" type="text" v-model="menuTime.start">-->
                </div>
              </div>
              <!-- 商品列表 -->
              <br>
              <div>
                <div class="text-left">
                  <button class="btn btn-success" @click="addRule">新增規則</button>
                </div>
                <div class="process-time-block" v-for="(rule, rIndex) in rule_list" style="max-width: 400px">
                  <div class="text-right m-b-10"><button class="btn btn-danger" @click="removeListItem(rule_list, rIndex)"><i class="fa fa-trash"></i></button></div>
                  <div>
                    <div class="input-group">
                    <span class="input-group-addon" style="text-align: left">
                      <span class="text-red">＊ </span>規則類型
                    </span>
                      <div>
                        <multiselect v-model="rule.rule_type"
                                    placeholder="規則類型" label="label" track-by="value" :options="ruleTypeOptions"
                                    :multiple="false" :allow-empty="true"></multiselect>
                      </div>
                    </div>
                    <br />
                  </div>
                  <div v-if="rule.rule_type.value === 1">
                    <div class="input-group">
                    <span class="input-group-addon" style="width: 120px; text-align: left;">
                      <span class="text-red">＊ </span>日期
                    </span>
                    <div>
                      <!---->
                      <!-- <date-time-picker :option="dateoption" :limit="startLimit"></date-time-picker> -->
                      <date-time-picker :date="rule.rule_date"  :option="dateoption_rule" :limit="limit_rule" ></date-time-picker>
                      <!-- <input id="datePicker" class="form-control" placeholder="YYYY-MM-DD" type="text" v-model="rule.rule_date" > -->
                    </div>
                    </div>
                    <br />
                  </div>
                  <div v-if="rule.rule_type.value === 2 || rule.rule_type.value === 3">
                    <div class="input-group">
                    <span class="input-group-addon" style="width: 120px; text-align: left;">
                      <span class="text-red">＊ </span>{{rule.rule_type.value === 2 ? '星期': '日期'}}
                    </span>
                    <div>
                      <multiselect v-model="rule.rule_day" style="width: 248px;"
                                  placeholder="星期" label="label" track-by="value" :options="offdaySetting.options.weekDay"
                                  :multiple="false" :allow-empty="true" v-if="rule.rule_type.value === 2"></multiselect>
                      <multiselect v-model="rule.rule_month_day" style="width: 248px"
                                  placeholder="幾號" label="label" track-by="value" :options="offdateSetting.options.dateDay"
                                  :multiple="false" :allow-empty="true" v-else-if="rule.rule_type.value === 3"></multiselect>
                      <input class="form-control" placeholder="日期" type="text" v-model="rule.rule_month_day" maxlength="1" v-else>
                    </div>
                    </div>
                    <br />
                  </div>
                  <div>
                    <div class="input-group">
                    <span class="input-group-addon" style="width: 120px; text-align: left;">
                      起始時間
                    </span>
                    <div>
                      <vue-timepicker manual-input placeholder="hh:mm" input-width="248px"  input-class="form-control" v-model="rule.rule_start_time"></vue-timepicker>
                      <!-- <input class="form-control" placeholder="" type="text" v-model="rule.rule_start_time" maxlength="8"> -->
                    </div>
                    </div>
                    <br />
                  </div>
                  <div>
                    <div class="input-group">
                    <span class="input-group-addon" style="width: 120px; text-align: left;">
                      結束時間
                    </span>
                    <div>
                      <vue-timepicker manual-input placeholder="hh:mm" input-width="248px" input-class="form-control" v-model="rule.rule_end_time"></vue-timepicker>
                      <!-- <input class="form-control" placeholder="" type="text" v-model="rule.rule_end_time" maxlength="8"> -->
                    </div>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="addStoresSetting.options.length > 0 && ($route.query.usage_type === '1' && $route.name === 'upDisableSchedule' || $route.name === 'crDisableSchedule')">
              <div class="col-xs-12 m-t-64 y-middle">
                <div class="inline-block pull-left text-left">
                  <h5 class="text-14-4 "><span class="text-red">＊</span>多店編輯限同菜單</h5>
                </div>
              </div>
              <div class="col-xs-12 p-10" >
                <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
                  <div class="text-left">
                    <div class="col-xs-12 p-x-0" >
                      <!-- <div class="col-md-7"><h5>不參與停賣店家
                      </h5></div>
                      <div class="col-md-5">
                        <h5>參與停賣店家
                        </h5>
                      </div> -->
                      <div class="left_store_sec text-14-4 ">不參與停賣店家</div>
                      <div class="middle_store_sec">&ensp; </div>
                      <div class="right_store_sec text-14-4 ">參與停賣店家</div>
                    </div>

                    <!-- 參與店家 -->
                    <!-- <muti-select-two-v2 v-if="addStoresSetting.options.length > 0" :setting="addStoresSetting"></muti-select-two-v2> -->
                    <v-multiselect-listbox v-if="addStoresSetting.options.length > 0" class="col-xs-12" :options="addStoresSetting.options"
                      :reduce-display-property="(option) => option.label"
                      :reduce-value-property="(option) => option.value"
                      :show-select-all-buttons="checkSelectAll"
                      search-options-placeholder="搜尋..."
                      selected-options-placeholder="搜尋..."
                      v-model="addStoresSetting.choose"
                    />
                    <div class="col-xs-12 text-right">
                      <p class="text-12">已選 {{this.addStoresSetting.choose.length}} 間</p>
                    </div>
                    <!-- <muti-select-two-v2 v-if="addStoresSetting_cr.options.length > 0" :setting="addStoresSetting_cr"> </muti-select-two-v2> -->
                    <!--{{addStoresSetting.choose}}-->
                  </div>
                </div>
              </div>
          </div>
          <div v-if="category.length>0" class="col-xs-12 y-middle">
            <div class="inline-block pull-left text-left">
              <h5><span class="text-red">＊</span> 未勾選者，將會取消停賣功能。</h5>
            </div>
          </div>
          <div class="col-xs-12 y-middle" v-if="category.length>0"><div class="hr-line"></div><div class="h3-title">商品時段停賣設定</div></div>
              <div class="col-xs-12 p-10">
                <div class="grid" style="width: 100%;">
                  <div class="col-xs-12 col-lg-4 grid-item p-5" v-for="(c, index) in category">
                    <div class="col-xs-12 card">
                      <div class="col-xs-12 m-b-5 text-left p-x-15">
                        <div class="text-right inline-block block-checkbox text-15" style="margin-right: 10px;">
                          <span class="text-dark-gray text-13">停賣</span>
                          <!--<span class="text-dark-gray text-13" style="margin-left: 18px;">訂購</span>-->
                          <!--<span class="text-dark-gray text-13" style="margin-left: 18px; margin-right: 5px;">顯示</span>-->
                        </div>
                      </div>
                      <div class="col-xs-12 card-title text-left p-x-15">
                        <span class="pull-left">{{c.name}}</span>
                        <div class="text-right inline-block m-r-15 block-checkbox">
                          <span class="checkbox-addmenu">
                            <input type="checkbox" v-model="c.is_disabled" :id="'c-' + c.product_id + '-is-add'" class="css-checkbox" @input="changeCategoryAdd(c)">
                            <label :for="'c-' + c.product_id + '-is-add'" class="css-label css-label-add"></label>
                          </span>
                        </div>
                      </div>
                      <div class="col-xs-12 text-left">
                        <ul class="nav p-x-15">
                          <li class="card-product" v-for="(p, index) in c.child_list">
                            <div :class="p.is_disabled?'delete-line':''">
                              {{p.name}} <small>{{p.remark? `(${p.remark})`: ''}}</small>
                              <div class="text-right inline-block block-checkbox">
                                <span class="checkbox-addmenu">
                                  <input type="checkbox" v-model="p.is_disabled" :id="'p-' + p.product_id + '-is-add'" class="css-checkbox"  @input="changeProductAdd(c, p)">
                                  <label :for="'p-' + p.product_id + '-is-add'" class="css-label css-label-add"></label>
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-xs-12 y-middle m-t-10 m-b-10" v-if="options.length>0"><div class="hr-line"></div><div class="h3-title">配料時段停賣設定</div></div>
              <div class="col-xs-12 p-10" v-if="options.length>0">
                <div class="grid" style="width: 100%;">
                  <div class="col-xs-12 col-lg-4 grid-item p-5">
                    <div class="col-xs-12 card">
                      <div class="col-xs-12 m-b-5 text-left p-x-15">
                        <div class="text-right inline-block block-checkbox text-15" style="margin-right: 10px;">
                          <span class="text-dark-gray text-13">停賣</span>
                        </div>
                      </div>
                      <div class="col-xs-12 card-title text-left p-x-15">
                        <span class="pull-left">配料</span>
                        <div class="text-right inline-block m-r-15 block-checkbox">
                          <span class="checkbox-addmenu">
                            <input v-model="adjustCheckbox" type="checkbox" id="adjustCheckbox" class="css-checkbox" @change="changeAdjustAdd()">
                            <label for="adjustCheckbox" class="css-label css-label-add"></label>
                          </span>
                        </div>
                      </div>
                      <div class="col-xs-12 text-left">
                        <ul class="nav p-x-15">
                          <li class="card-product" v-for="(a, index) in options">
                            <div :class="a.is_disabled?'delete-line':''">
                              {{a.name}} <small>{{a.remark? `(${a.remark})`: ''}}</small>
                              <div class="text-right inline-block block-checkbox">
                                <span class="checkbox-addmenu">
                                  <input type="checkbox" v-model="a.is_disabled" :id="'a-' + index + '-is-add'" class="css-checkbox" @change="checkAdjust(a)">
                                  <label :for="'a-' + index + '-is-add'" class="css-label css-label-add"></label>
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                    </div>
                  </div>
                </div>
              </div> -->

          </div>
          
          <div class="box-footer text-center">
            <button @click="$router.go(-1)" class="btn btn-fail text-black">
              返回
            </button>
            <button class="btn btn-success" @click="checkSetting()" v-if="!up">
              新增
            </button>
            <button class="btn btn-success" @click="checkSetting()" v-else>
              更新
            </button>
          </div>
        </div>
      </div>
    </div>
    <m-modal :option="delOption" @trigger="trigger"></m-modal>
    <m-modal :option="delItemOption" @trigger="trigger"></m-modal>
  </section>
</template>

<script>
// Require needed datatables modules
import { mapGetters } from 'vuex'
import moment from 'moment'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import VueTimepicker from 'vue2-timepicker'
import $ from 'jquery'
import Masonry from 'masonry-layout'

export default {
  components: {
    'date-time-picker': datetimePicker,
    VueTimepicker
  },
  data () {
    return {
      menuState: 4,
      name: '',
      description: '',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      bindList: [],
      is_enabled: 1,
      vendor_custom_id: '',
      alias_name: '',
      prod_description: '',
      prod_description_list: [{ prod_description: '' }],
      addAmount: 5,
      settingId: '',
      type: 1, // 1 = 小圖， 2 = 大圖
      currentId: '',
      smImgSrc: '',
      up: false,
      enableOption: [
        {label: '啟用', value: 1},
        {label: '關閉', value: 0}
      ],
      delOption: {
        id: 'delModal',
        title: '刪除時段停賣設定',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delDisableSchedule'
          }
        ]
      },
      delItemOption: {
        id: 'delModal',
        title: '刪除商品設定',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delDisableScheduleItem'
          }
        ]
      },
      // time
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      dateoption_rule: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px 12px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'width': '248px',
          'min-width': '248px',
          'text-align': 'left'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px 12px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'width': '280px',
          'min-width': '280px',
          'text-align': 'left'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          from: moment().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      limit_rule: [
        {
          type: 'fromto',
          from: moment().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      prodTypeOptions: [
        { label: '商品', value: 1 },
        { label: '套餐', value: 3 },
        { label: '配料', value: 2 },
        { label: '商品分類', value: 10 },
        { label: '品項選擇區', value: 11 },
        { label: '配料群組', value: 20 }
      ],
      srcIdTypeOptions: [
        { label: '廠商料號', value: 1 },
        { label: '平台商品ID', value: 2 }
      ],
      item_list: [],
      rule_list: [],
      ruleTypeOptions: [
        { label: '每日', value: 0 },
        { label: '指定日期', value: 1 },
        { label: '指定星期', value: 2 },
        { label: '每月幾號', value: 3 }
      ],
      offdaySetting: {
        options: {
          weekDay: [
            {label: '週日', value: 1},
            {label: '週一', value: 2},
            {label: '週二', value: 3},
            {label: '週三', value: 4},
            {label: '週四', value: 5},
            {label: '週五', value: 6},
            {label: '週六', value: 7}
          ]
        }
      },
      offdateSetting: {
        options: {
          dateDay: [
            {label: '1號', value: 1},
            {label: '2號', value: 2},
            {label: '3號', value: 3},
            {label: '4號', value: 4},
            {label: '5號', value: 5},
            {label: '6號', value: 6},
            {label: '7號', value: 7},
            {label: '8號', value: 8},
            {label: '9號', value: 9},
            {label: '10號', value: 10},
            {label: '11號', value: 11},
            {label: '12號', value: 12},
            {label: '13號', value: 13},
            {label: '14號', value: 14},
            {label: '15號', value: 15},
            {label: '16號', value: 16},
            {label: '17號', value: 17},
            {label: '18號', value: 18},
            {label: '19號', value: 19},
            {label: '20號', value: 20},
            {label: '21號', value: 21},
            {label: '22號', value: 22},
            {label: '23號', value: 23},
            {label: '24號', value: 24},
            {label: '25號', value: 25},
            {label: '26號', value: 26},
            {label: '27號', value: 27},
            {label: '28號', value: 28},
            {label: '29號', value: 29},
            {label: '30號', value: 30},
            {label: '31號', value: 31}
          ]
        }
      },
      brandSelect: {
        value: 999999,
        label: '==品牌=='
      },
      storeSelect: {
        value: 999999,
        label: '所有門市'
      },
      // 影響菜單是否能讀取到店家
      brandBrief: [],
      storeBrief: [],
      addStoresSetting: {
        options: [],
        choose: []
      },
      // 停賣菜單
      menuId: null,
      brandId: null,
      category: [],
      product: [],
      prodNumList: {},
      menuInfo: {},
      menuList: '',
      // if created checkbox all true, if not all false
      created: false,
      getTimes: 0,
      time: 0,
      accessory: [],
      disTableList: [],
      adjustCheckbox: false,
      options: [],
      // 停賣菜單
      trigger_load_menu: true,
      loadmenu_id: null
    }
  },
  methods: {
    // 取得停賣菜單的列表
    getOnlineMenu () {
      var self = this
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + this.brandSelect.value
      if (this.$route.query.usage_type === '2') {
        if (self.loadmenu_id) {
          url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&store_id=' + this.loadmenu_id
        } else {
          url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&store_id=' + this.$route.query.store_id
        }
      } else if (this.$route.query.usage_type === '1') {
        if (self.loadmenu_id) {
          url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&store_id=' + this.loadmenu_id
        } else {
          url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + this.$route.query.brand_id
        }
      }
      if (this.storeSelect.value !== 999999 && this.storeSelect.value !== null && !this.$route.query.usage_type) url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&store_id=' + this.storeSelect.value
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.menuList = response.data.menu_list
          self.total = response.data.total
          if (self.storeSelect.value === 999999) {
            self.menuId = self.menuList[0].id
            self.getMenuInfo(self.menuList[0].id)
          } else if (self.storeSelect.value !== 999999 && self.storeSelect.value !== null) {
            self.menuId = self.menuList[0].id
            self.getMenuInfo(self.menuList[0].id)
          }
        }
      })
    },
    // 停賣菜單
    init () {
      // this.getMenuInfo()
      // this.getMenuResource()
      // this.getMenuContainer()
    },
    isActive (index) {
      if (index === 1) return true
      else return false
    },
    // 時段停賣配料點選的行為
    changeAdjustAdd () {
      this.options.forEach(a => {
        a.is_disabled = this.adjustCheckbox
        if (a.is_disabled === true) {
          const obj = {
            product_type: this.prodTypeOptions.find(function (opt) { return opt.value === a.type }),
            src_id_type: { label: '廠商料號', value: 1 },
            product_id: a.optionIds[0]
          }
          this.item_list.push(obj)
        } else {
          // 廠商代碼
          const index = this.item_list.findIndex(item => item.product_id === a.optionIds[0])
          if (index > -1) {
            this.item_list.splice(index, 1)
          }
          // 平台商品
          const pindex = this.item_list.findIndex(pitem => pitem.product_id === a.optionIds[0])
          if (pindex > -1) {
            this.item_list.splice(pindex, 1)
          }
        }
      })
    },
    // 時段停賣配料點選的行為
    checkAdjust (adjust) {
      this.adjustCheckbox = true
      this.options.forEach(a => {
        if (!a.is_disabled) {
          this.adjustCheckbox = false
          return false
        }
      })
      if (adjust.is_disabled === true) {
        const obj = {
          product_type: this.prodTypeOptions.find(function (opt) { return opt.value === adjust.type }),
          src_id_type: { label: '廠商料號', value: 1 },
          product_id: adjust.optionIds[0]
        }
        this.item_list.push(obj)
      } else {
        // 廠商代碼
        const index = this.item_list.findIndex(item => item.product_id === adjust.optionIds[0])
        if (index > -1) {
          this.item_list.splice(index, 1)
        }
        // 平台商品
        const pindex = this.item_list.findIndex(pitem => pitem.product_id === adjust.optionIds[0])
        if (pindex > -1) {
          this.item_list.splice(pindex, 1)
        }
      }
    },
    showMenu () {
      if ($('.grid') && $('.grid-item')) {
        var m = new Masonry('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        })
        m.reloadItems()
        m.layout()
      }
    },
    getProduct (index) {
      return this.product[index]
    },
    gotoFrom () {
      if (this.menuId) this.$router.push('/upMenu/' + this.brandId + '/' + this.menuId)
      else this.$router.push('/crOption')
    },
    gotoNext () {
      // this.joinMenu()
      if (!this.addStoresSetting.choose.length && !this.$route.params.store_id) {
        this.$notify({
          title: '錯誤',
          text: '未選擇停賣店家',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else this.disProductList()
      // this.$router.push('/crJoinMenu')
    },
    setChoose () {
      var self = this
      var array = []
      if (self.$route.name.indexOf('up') > -1) {
        self.marketing.attend_stores.forEach(function (brand) {
          brand.store_list.forEach(function (store) {
            var curStore = store.store_id
            array.push(curStore)
          })
        })
        self.addStoresSetting.choose = array
      }
    },
    getMenuInfo (menuId) {
      // const storeId = this.$route.params.store_id
      var url = '/onlineMenu/' + menuId + '/productBrief'
      // if (storeId) {
      //   url += '?store_id=' + storeId
      // }
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const menu = response.data.brief
          this.category = menu.category_list
          const optionList = []
          this.category.forEach(j => {
            this.item_list.forEach(item => {
              j.child_list.forEach(jc => {
                if (item.src_id_type.value === 1) {
                  if (jc.vendor_custom_id === item.product_id) {
                    jc.is_disabled = 1
                  }
                } else if (item.src_id_type.value === 2) {
                  if (jc.product_id === item.product_id) {
                    jc.is_disabled = 1
                  }
                }
              })
            })
            const index = j.child_list.findIndex(k => k.is_disabled === 0)
            if (index === -1) {
              j.is_disabled = true
            }
          })
          menu.adjust_list.forEach(e => {
            e.child_list.forEach(a => {
              if (a.sub_type === 0) {
                this.item_list.forEach(item => {
                  if (item.src_id_type.value === 1) {
                    if (a.vendor_custom_id === item.product_id) {
                      a.is_disabled = 1
                    }
                  } else if (item.src_id_type.value === 2) {
                    if (a.product_id === item.product_id) {
                      a.is_disabled = 1
                    }
                  }
                })
                optionList.push(a)
              }
            })
          })
          this.options = optionList.map(q => {
            return {
              name: q.name,
              is_disabled: q.is_disabled,
              optionIds: [q.vendor_custom_id],
              remark: q.remark,
              sub_type: q.sub_type,
              type: q.type
            }
          })
          const index = this.options.findIndex(k => !k.is_disabled)
          if (index === -1) {
            this.adjustCheckbox = true
          }
          // 讀取多選
          if (response.data.store_list.length > 0) {
            this.addStoresSetting.options = response.data.store_list.map(x => {
              return {
                value: x.id,
                label: x.name
              }
            })
          }
          // 如果store_id為0, 且無可選擇門市且為品牌就為全選
          // alert(this.$route.query.store_id)
          if (this.$route.query.usage_type === '1' && this.$route.query.store_id === '0' && this.addStoresSetting.choose.length === 0) {
            this.addStoresSetting.choose = response.data.store_list.map(x => {
              return x.id
            })
          }
        }
      })
    },
    disProductList () {
      var stores = this.addStoresSetting.choose.length > 0 ? this.addStoresSetting.choose : [Number(this.$route.params.store_id)]
      let productAry = []
      let packageAry = []
      this.category.forEach(k => {
        const product = k.child_list.filter(x => x.type === 1 && x.is_disabled).map(j => j.product_id)
        if (product.length > 0) {
          productAry = [...productAry, product]
        }
        const packages = k.child_list.filter(x => x.type === 3 && x.is_disabled).map(j => j.product_id)
        if (packages.length > 0) {
          packageAry = [...packageAry, packages]
        }
      })
      let optionAry = []
      this.options.forEach(z => {
        if (z.is_disabled) {
          optionAry.push(z.optionIds)
        }
      })
      const data = {
        store_list: stores,
        setting: {
          product_list: {
            disable: productAry.flat()
          },
          package_list: {
            disable: packageAry.flat()
          },
          option_list: {
            disable: optionAry.flat()
          }
        }
      }
      var url = '/onlineMenu/' + this.$route.params.menu_id + '/productListStatus'
      this.getDataH('post', url, data, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '訊息',
            text: '成功更新停賣資訊',
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    getDisItemList () {
      this.disTableList = []
      var self = this
      var url = '/store/' + this.$route.params.store_id + '/disableItemList'
      var adjust = this.adjust
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.disTableList = response.data.item_list
          var disCategory = self.disTableList.category
          disCategory.forEach(function (c) {
            c.id_list.forEach(function (cId) {
              self.category.find(function (category) {
                if (category.category_id === cId) category.is_disabled = true
              })
            })
          })
          var disProd = self.disTableList.product
          disProd.forEach(function (p) {
            p.id_list.forEach(function (pId) {
              self.category.forEach(function (cc) {
                cc.product_list.find(function (prod) {
                  if (prod.product_id === pId) prod.is_disabled = true
                })
                // 暫時沒有package
                /*
                cc.package_list.find(function (pack) {
                  if (pack.package_id === pId) pack.is_disabled = true
                })
                */
              })
            })
          })
          var disOption = self.disTableList.option
          disOption.forEach(e => {
            e.id_list.forEach(l => {
              var index = adjust.findIndex(x => x.adjustIds.indexOf(l) > -1)
              adjust[index].is_disabled = true
            })
          })
        }
      })
    },
    choseAllProduct (category) {
      this.category.filter(function (elem, index, obj) {
        if (elem.category_id === category.category_id) {
          elem.is_enable = true
          elem.is_visible = true
          elem.is_disabled = true
          if (elem.product_list.length) {
            for (var i = 0; i < elem.product_list.length; i++) {
              var product = elem.product_list[i]
              product['is_enable'] = true
              product['is_visible'] = true
              product['is_disabled'] = true
              if (product.combine_list) {
                for (var j = 0; j < product.combine_list.length; j++) {
                  var combine = product.combine_list[j]
                  combine['is_enable'] = true
                  combine['is_visible'] = true
                  combine['is_disabled'] = true
                }
              }
            }
          }
        }
      })
    },
    // 修改整個類別
    changeCategoryAdd (category) {
      const self = this
      category.is_disabled = !category.is_disabled
      category.child_list.forEach(function (product) {
        product['is_disabled'] = category.is_disabled
        if (product['is_disabled'] === true) {
          const obj = {
            product_type: self.prodTypeOptions.find(function (opt) { return opt.value === product.type }),
            src_id_type: { label: '廠商料號', value: 1 },
            product_id: product.vendor_custom_id
          }
          self.item_list.push(obj)
        } else {
          // 廠商代碼
          const index = self.item_list.findIndex(item => item.product_id === product.vendor_custom_id)
          if (index > -1) {
            self.item_list.splice(index, 1)
          }
          // 平台商品
          const pindex = self.item_list.findIndex(pitem => pitem.product_id === product.vendor_custom_id)
          if (pindex > -1) {
            self.item_list.splice(pindex, 1)
          }
        }
      })
    },
    changeProductAdd (category, product) {
      product.is_disabled = !product.is_disabled
      if (product.is_disabled === true) {
        const obj = {
          product_type: this.prodTypeOptions.find(function (opt) { return opt.value === product.type }),
          src_id_type: { label: '廠商料號', value: 1 },
          product_id: product.vendor_custom_id
        }
        this.item_list.push(obj)
      } else {
        // 廠商代碼
        const index = this.item_list.findIndex(item => item.product_id === product.vendor_custom_id)
        if (index > -1) {
          this.item_list.splice(index, 1)
        }
        // 平台商品
        const pindex = this.item_list.findIndex(pitem => pitem.product_id === product.product_id)
        if (pindex > -1) {
          this.item_list.splice(pindex, 1)
        }
      }
      const isDisabled = category.child_list.filter(x => x.is_disabled === 0)
      if (isDisabled.length === 0) {
        category.is_disabled = false
      }
    },
    // 停賣菜單資料導入
    // 取得品牌資料
    getBrandBrief () {
      return new Promise((resolve, reject) => {
        try {
          const self = this
          const url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
          this.getDataH('get', url, null, function (response) {
            if (response.data.status === 200) {
              var bList = response.data.list
              for (let i = 0; i < bList.length; i++) {
                let obj = {label: bList[i].name, value: bList[i].brand_id}
                if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
                self.brandBrief.push(obj)
                if (self.$route.name === 'crDisableSchedule' && self.getRoleType === 99) {
                  if (Number(self.$route.query.brand_id) === obj.value) {
                    self.brandSelect = obj
                  }
                } else if (i === 0 && self.$route.params.usage_type !== 2) {
                  self.brandSelect = obj
                }
              }
            }
            resolve()
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    getStoreBrief (brandId) {
      var self = this
      self.storeBrief = []
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj
            } else if (i === 0) self.storeSelect.value = 999999
            // 目前由這判斷是否讀取菜單與否
          }
          // 用於讀取品牌，在尚未選擇品牌
          if (!self.$route.query.usage_type) {
            self.addStoresSetting.options = sList.map(x => {
              return {
                value: x.store_id,
                label: x.name
              }
            })
            // self.addStoresSetting.choose = []
          }
          if (self.$route.name === 'upDisableSchedule') {
            self.getOnlineMenu()
          }
        }
      })
    },
    removeListItem (list, index) {
      list.splice(index, 1)
    },
    addRule () {
      const rule = { rule_type: { label: '每日', value: 0 }, rule_date: {time: ''}, rule_day: '', rule_month_day: '', rule_start_time: '', rule_end_time: '' }
      this.rule_list.push(rule)
    },
    removeItem (index) {
      this.item_list.splice(index, 1)
    },
    addItem () {
      const newItem = { product_type: { label: '商品', value: 1 }, src_id_type: { label: '廠商料號', value: 1 }, product_id: '' }
      this.item_list.push(newItem)
    },
    trigger (event) {
      if (event === 'delDisableSchedule') {
        if (this.$route.name === 'upDisableSchedule') this.delDisableSchedule()
      } else if (event === 'delDisableScheduleItem') this.delDisableScheduleItem()
    },
    clickCurrent (itemId, index) {
      this.currentId = itemId
      this.delOption.body = '是否刪除第' + (index + 1) + '張大圖？'
    },
    checkSetting () {
      let msg = ''
      if (!this.menuTime.start.time) {
        msg = '請選擇開始時間'
        this.getToast(msg)
      } else if (!this.menuTime.end.time) {
        msg = '請選擇結束時間'
        this.getToast(msg)
      } else if (this.rule_list.length === 0) {
        msg = '請新增規則'
        this.getToast(msg)
      } else if (this.item_list.length > 0) {
        const firstItem = this.item_list[0]
        // const firstOption = this.options
        if (this.addStoresSetting.choose.length === 0) {
          msg = '請選擇門市'
        } else if (!firstItem.product_id.trim()) {
          if (firstItem.src_id_type === 1) msg = '請輸入廠商料號'
          else msg = '請輸入平台商品ID'
        }
        this.getToast(msg)
      } else if (this.addStoresSetting.choose.length === 0) {
        msg = '請選擇門市'
        this.getToast(msg)
      } else {
        msg = '請選擇停賣商品，或選擇其他門市'
        this.getToast(msg)
      }
    },
    getToast (msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        const rName = this.$route.name
        // set data
        const data = {
          item_list: [],
          store_list: [],
          start_date: this.menuTime.start.time,
          end_date: this.menuTime.end.time
        }
        if (this.name) data.name = this.name
        if (this.description) data.description = this.description
        // 商品停賣資料
        this.item_list.forEach(function (item) {
          const obj = {
            product_type: item.product_type.value,
            src_id_type: item.src_id_type.value
          }
          if (obj.src_id_type === 1) obj.vendor_custom_id = item.product_id
          else obj.product_id = item.product_id
          data.item_list.push(obj)
        })
        // 新增門市
        this.addStoresSetting.choose.forEach(function (store) {
          data.store_list.push(store)
        })
        // 更新商品停賣資料
        // this.category.forEach(function(cg){
        //   cg.
        // })
        // 商品停賣資料
        data.rule_list = []
        if (this.rule_list.length) {
          this.rule_list.forEach(function (rule) {
            const obj = {
              rule_type: rule.rule_type.value
            }
            if (obj.rule_type === 1) obj.rule_date = rule.rule_date.time
            else if (obj.rule_type === 2) obj.rule_day = rule.rule_day.value
            else if (obj.rule_type === 3) obj.rule_day = rule.rule_month_day.value

            if (rule.rule_start_time && rule.rule_end_time) {
              obj.rule_start_time = rule.rule_start_time
              obj.rule_end_time = rule.rule_end_time
            }
            data.rule_list.push(obj)
          })
        }
        if (rName === 'crDisableSchedule') this.crDisableSchedule(data)
        else if (rName === 'upDisableSchedule') this.crDisableSchedule(data)
      }
    },
    crDisableSchedule (data) {
      var self = this
      const rName = this.$route.name
      let brandId = null
      if (rName === 'crDisableSchedule') {
        brandId = this.brandSelect.value
      } else if (rName === 'upDisableSchedule') {
        brandId = this.$route.query.brand_id
      }
      const storeId = this.storeSelect.value
      var url = '/brand/' + brandId + '/productDisableScheduleSetting/group'
      if (storeId !== 999999 && this.getRoleType === 10) url = '/store/' + storeId + '/productDisableScheduleSetting/group'
      if (this.$route.params.setting_id) url = url + '/' + this.$route.params.setting_id // 編輯
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          if (self.getRoleType === 99 || self.getRoleType === 30) {
            self.$router.push('/disItemScheduleTable?brand=' + brandId)
          } else if (self.getRoleType === 10 && storeId !== 999999) {
            self.$router.push('/disItemScheduleTable?store=' + storeId)
          } else {
            self.$router.push('/disItemScheduleTable')
          }
        }
      })
    },
    delDisableScheduleItem () {
      var self = this
      var url = '/brand/' + this.$route.query.brand_id + '/productDisableScheduleSetting/' + this.$route.params.setting_id
      if (this.$route.query.usage_type === '2') url = '/store/' + this.$route.query.store_id + '/productDisableScheduleSetting/' + this.$route.params.setting_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.go(-1)
        }
      })
    },
    delDisableSchedule () {
      var self = this
      var url = '/brand/' + this.$route.query.brand_id + '/productDisableScheduleSetting/group/' + this.$route.params.setting_id
      if (this.$route.query.usage_type === '2') url = '/store/' + this.$route.query.store_id + '/productDisableScheduleSetting/group/' + this.$route.params.setting_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.go(-1)
        }
      })
    },
    delProductAlias () {
      var self = this
      const brandId = this.$route.params.brand_id
      var url = '/brand/' + this.$route.params.brand_id + '/productAliasSetting/' + this.$route.params.setting_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.push('/brandProductSetting/' + brandId)
        }
      })
    },
    upProductDescription () {
      var self = this
      const brandId = this.$route.params.brand_id
      let items = []
      this.prod_description_list.forEach((item, i) => {
        if (item.prod_description) items.push(item.prod_description)
      })
      var url = '/brand/' + this.$route.params.brand_id + '/productDescriptionSetting/' + this.$route.params.setting_id
      const data = {
        vendor_custom_id: this.vendor_custom_id,
        is_enabled: this.is_enabled,
        item_list: items
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.push('/brandProductSetting/' + brandId)
        }
      })
    },
    upProductAlias () {
      var self = this
      const brandId = this.$route.params.brand_id
      const items = [this.alias_name]
      var url = '/brand/' + this.$route.params.brand_id + '/productAliasSetting/' + this.$route.params.setting_id
      const data = {
        vendor_custom_id: this.vendor_custom_id,
        is_enabled: this.is_enabled,
        item_list: items
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.push('/brandProductSetting/' + brandId)
        }
      })
    },
    getDisableSchedule () {
      return new Promise((resolve, reject) => {
        try {
          var self = this
          // var url = '/brand/' + this.$route.query.brand_id + '/productDisableScheduleSetting/group'
          // var url = '/brand/' + this.$route.query.brand_id + '/productDisableScheduleSetting/' + this.$route.params.setting_id
          // if (this.$route.query.usage_type === '2') url = '/store/' + this.$route.query.store_id + '/productDisableScheduleSetting/' + this.$route.params.setting_id
          var url = '/brand/' + this.$route.query.brand_id + '/productDisableScheduleSetting/group/' + this.$route.params.setting_id
          if (this.$route.query.usage_type === '2') url = '/store/' + this.$route.query.store_id + '/productDisableScheduleSetting/group/' + this.$route.params.setting_id
          // url = '/store/' + this.$route.query.store_id + '/productDisableScheduleSetting/' + this.$route.params.setting_id
          self.item_list = []
          this.getDataH('get', url, null, function (response) {
            if (response.data.status === 200) {
              const sInfo = response.data.group
              // self.brandSelect.value = sInfo.brand_id
              // self.brandSelect.label = sInfo.brand_name
              if (sInfo.store_list.length > 0) self.loadmenu_id = sInfo.store_list[0].store_id
              if (sInfo.store_id) self.storeSelect.value = sInfo.store_id
              self.name = sInfo.name
              self.description = sInfo.description
              self.menuTime.start.time = sInfo.start_date
              self.menuTime.end.time = sInfo.end_date
              // usage_type為1時store_list為空代表套用到brand_id下所有門市
              // usage_type為2時store_list為空代表套用到store_id
              if (self.$route.query.usage_type === '1') {
                if (sInfo.store_list.length > 0) {
                  self.addStoresSetting.choose = sInfo.store_list.map(x => {
                    return x.store_id
                  })
                }
              } else if (self.$route.query.usage_type === '2') {
                if (sInfo.store_list.length > 0) {
                  self.addStoresSetting.choose = sInfo.store_list.map(x => {
                    return x.store_id
                  })
                } else {
                  self.addStoresSetting.choose = sInfo.store_list.map(x => {
                    return x.store_id
                  })
                }
              }
              sInfo.item_list.forEach(function (item) {
                const obj = {
                  product_type: self.prodTypeOptions.find(function (opt) { return opt.value === item.product_type }),
                  src_id_type: self.srcIdTypeOptions.find(function (opt) { return opt.value === item.src_id_type }),
                  product_id: item.vendor_custom_id || item.product_id
                }
                self.item_list.push(obj)
              })
              sInfo.rule_list.forEach(function (rule) {
                if (rule.rule_start_time === null) {
                  rule.rule_start_time = ''
                }
                if (rule.rule_end_time === null) {
                  rule.rule_end_time = ''
                }
                const obj = {
                  rule_type: self.ruleTypeOptions.find(function (opt) { return rule.rule_type === opt.value }),
                  rule_date: {time: ''},
                  rule_day: '',
                  rule_month_day: {label: '', value: null},
                  rule_start_time: rule.rule_start_time,
                  rule_end_time: rule.rule_end_time
                }
                if (rule.rule_date) obj.rule_date.time = rule.rule_date
                if (rule.rule_type === 2 && rule.rule_day) obj.rule_day = self.offdaySetting.options.weekDay.find(function (week) { return week.value === rule.rule_day })
                else if (rule.rule_type === 3 && rule.rule_day) {
                  obj.rule_month_day.value = rule.rule_day
                  obj.rule_month_day.label = rule.rule_day + '號'
                }
                self.rule_list.push(obj)
              })
            }
            resolve()
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    getProductAlias () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/productAliasSetting/' + this.$route.params.setting_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const setting = response.data.setting
          self.vendor_custom_id = setting.vendor_custom_id
          self.alias_name = setting.item_list[0].name
          if (!setting.is_enabled) self.is_enabled = 0
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    checkSelectAll () {
      if (this.$route.name === 'upDisableSchedule') {
        return true
      } else if (this.$route.name === 'crDisableSchedule') {
        if (this.addStoresSetting.choose.length > 0) {
          return true
        } else {
          return false
        }
      }
    },
    // 停賣菜單
    checkInput () {
      return this.$parent.checkInput
    },
    storeName () {
      var sId = parseInt(this.$route.params.store_id, 10)
      if (sId) {
        var sName = this.addStoresSetting.options.find(function (o) { return sId === o.value })
        if (sName) return sName.label + '菜單'
      }
      return ''
    },
    // 停賣菜單
    tab () {
      var rName = this.$route.name
      switch (rName) {
        case 'crProductImg':
        case 'upProductImg':
          return 1
        case 'crPackageImg':
        case 'upPackageImg':
          return 3
        case 'crCategoryImg':
        case 'upCategoryImg':
          return 10
      }
    },
    tabName () {
      switch (this.tab) {
        case 2: return '配料'
        case 20: return '配料群組'
        case 10: return '商品分類'
        case 1: return '商品'
        case 11: return '品項選擇區'
        case 3: return '套餐'
      }
    },
    tabNamePlaceholder () {
      switch (this.tab) {
        case 2: return '配料名稱'
        case 20: return '配料群組名稱'
        case 10: return '商品分類名稱'
        case 1: return '商品名稱'
        case 11: return '品項選擇區名稱'
        case 3: return '套餐名稱'
      }
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    menuState () {
      this.tableIndex = 1
      this.pageGroup = 1
    },
    'brandSelect.value' () {
      // if (!this.$route.query.usage_type) {
      this.storeBrief = []
      this.addStoresSetting = {
        options: [],
        choose: []
      }
      this.category = []
      this.options = []
      this.item_list = []
      this.rule_list = []
      this.trigger_load_menu = true
      this.getStoreBrief(this.brandSelect.value)
      // }
    },
    'addStoresSetting.choose' () {
      if (this.addStoresSetting.choose.length === 1 && this.trigger_load_menu === true && !this.$route.query.usage_type) {
        this.storeSelect.value = this.addStoresSetting.choose[0]
        this.getOnlineMenu()
        this.trigger_load_menu = false
      } else if (this.addStoresSetting.choose.length === 0) {
        if (!this.$route.query.usage_type) {
          this.addStoresSetting.options = this.storeBrief.map(x => {
            return {
              value: x.value,
              label: x.label
            }
          })
            // self.addStoresSetting.choose = []
          this.trigger_load_menu = true
        }
      }
    },
    'menuTime.start.time' () {
      const date = new Date(this.menuTime.start.time)
      let startdate = new Date(date)
      startdate.setDate(startdate.getDate() - 1)
      this.limit_rule[0].from = startdate.toISOString().split('T')[0]
    },
    'menuTime.end.time' () {
      const date = new Date(this.menuTime.end.time)
      let enddate = new Date(date)
      enddate.setDate(enddate.getDate() + 1)
      this.limit_rule[0].to = enddate.toISOString().split('T')[0]
    }
  },
  async created () {
    await this.getBrandBrief()
    // if (this.$route.name === 'crDisableSchedule') {
    //   if (this.$route.query.brand_id) {
    //     // this.brandSelect.value = this.$route.query.brand_id
    //   }
    // }
    if (this.$route.name === 'upDisableSchedule') {
      this.up = true
      // this.getStoreBrief(this.$route.query.brand_id)
      await this.getDisableSchedule()
    } else if (this.$route.name === 'upProductDescription') {
      this.up = true
      this.getProductDescription()
    }
  },
  // 停賣菜單
  mounted () {
    this.showMenu()
  },
  updated () {
    this.showMenu()
    // if ($('body').hasClass('pace-running') > 0) this.getTimes = this.getTimes + 1
  }
  // 停賣菜單
}
</script>
<style lang="sass">
$default-color: #e1456d
$light-gray: rgb(238, 238, 238)
.label-text-60-p
  font-size: 60% !important
.m-t-10
  margin-top: 10px !important
.m-b-5
  margin-bottom: 5px !important
.m-r-5
  margin-right: 5px !important
.m-r-20
  margin-right: 20px !important
.m-r-15
  margin-right: 15px !important
.m-t-64
  margin-top: 64px !important
.display-time
  font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif
  padding: 6px 12px !important
.multiselect__placeholder
  padding: 0px !important
.msl-search-list-input
  border: 1px solid #ddd
.msl-searchable-list__items
  border: 1px solid #ddd !important
.msl-searchable-list__item
  border-bottom: 1px solid #ddd !important
.left_store_sec
  float: left;
  width: calc(50% - 30px);
.middle_store_sec
  float: left;
  width: 40px;
  margin: 0px 4px;
.right_store_sec
  float: left;
  width: calc(50% - 30px);
.block-checkbox
  right: 0px
  position: absolute
  top: 3px
.card-title .block-checkbox
  top: 8px
.checkbox-visible, .checkbox-enable
  margin-left: 20px
.text-dark-gray
  color: #333 !important
.text-light-gray
  color: #666 !important
.text-13
  font-size: 13px !important
.text-14-4 
  font-weight: normal
  font-size: 14.4px !important
.multiselect__single
  font-size: 14.4px !important
.msl-search-list-input
  font-size: 14.4px !important
.btn-option-show
  background: #ffffff
  border: 1px solid $default-color
  min-width: 100px
  font-size: 15px
  border-radius: 5px
  cursor: auto
input[type="checkbox"]
  margin-left: 0
  padding: 0
input[type=checkbox].css-checkbox
  position: absolute
  overflow: hidden
  clip: rect(0 0 0 0)
  height: 1px
  width: 1px
  margin: -1px
  padding: 0px
  border: 0
input[type=checkbox].css-checkbox+label.css-label
  padding-left: 22px
  height: 16px
  width: 16px
  display: inline-block
  line-height: 15px
  background-repeat: no-repeat
  background-position: 0 0
  font-size: 13px
  vertical-align: middle
  cursor: pointer
  opacity: 1
input[type=checkbox].css-checkbox+label.css-label:hover
  opacity: 0.5
input[type=checkbox].css-checkbox:checked+label.css-label
  background-position: 0 -17px
.css-label:not(.css-label-add)
  background-image: url(/static/img/checkbox.png)
  background-size: 16px
.css-label.css-label-add
  background-image: url(/static/img/checkbox-delete.png)
  background-size: 16px
input[type=checkbox].css-checkbox+label.css-label.disabled:hover
  opacity: 1
.delete-line
  text-decoration: line-through;
.box-border
  border-top: 1px solid #e1456d;;
.h3-title
  color: #e1456d;
  font-size: 24px;
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #fff;
.hr-line
  position: absolute;
  width: 100%;
  display: inline-lock;
  border-top: 1px solid #e1456d;
  top: 19px;
small
  color: dimgrey
.menu-info
  min-height: 120px
  width: 100%
  text-align: center
  *
    padding: 0
    margin: 0
    line-height: 25px
.m-b-15
  margin-bottom: 15px !important
.btn-edit-all, .btn-del-all
  margin-right: 15px
  z-index: 100
.nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
  display: none !important
.fn-gantt .leftPanel
  width: 100px !important
.fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
  font-size: 14px
.fn-gantt .navigate
  padding: 10px 0 10px 10px !important
@media screen and (max-width: 499px)
  .min-m-t-10
    margin-top: 25px
</style>
<style lang="sass" scoped>
  table.table-bordered tbody th, table.table-bordered tbody td
    vertical-align: middle
</style>



// WEBPACK FOOTER //
// DisScheduleProdTemp.vue?1701c376